/* Parfumence Magazine — sommaire auto + scrollspy. Vanilla, sans dépendance. */
(function () {
  function slugify(str) {
    return (str || '')
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\s-]/g, '')
      .trim().replace(/\s+/g, '-').substring(0, 60) || 'section';
  }

  function initArticle(root) {
    var content = root.querySelector('[data-pf-content]');
    var toc = root.querySelector('[data-pf-toc]');
    if (!content || !toc) return;

    var headings = content.querySelectorAll('h2, h3');
    var items = [];
    var used = {};
    headings.forEach(function (h) {
      if (!h.textContent.trim()) return;
      var id = h.id;
      if (!id) {
        id = slugify(h.textContent);
        while (used[id]) { id = id + '-1'; }
        h.id = id;
      }
      used[id] = true;
      items.push({ id: id, text: h.textContent.trim(), level: h.tagName === 'H3' ? 3 : 2 });
    });

    if (items.length < 3) { toc.remove(); root.classList.remove('pf-layout--toc'); return; }

    var list = toc.querySelector('[data-pf-toc-list]');
    var frag = document.createDocumentFragment();
    items.forEach(function (it) {
      var li = document.createElement('li');
      li.className = it.level === 3 ? 'lvl-3' : 'lvl-2';
      var a = document.createElement('a');
      a.href = '#' + it.id;
      a.textContent = it.text;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById(it.id);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.replaceState(null, '', '#' + it.id);
        }
      });
      li.appendChild(a);
      frag.appendChild(li);
    });
    list.appendChild(frag);

    var links = list.querySelectorAll('a');
    if ('IntersectionObserver' in window) {
      var map = {};
      links.forEach(function (l) { map[l.getAttribute('href').slice(1)] = l; });
      var current = null;
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            if (current) current.classList.remove('is-active');
            current = map[en.target.id];
            if (current) current.classList.add('is-active');
          }
        });
      }, { rootMargin: '-90px 0px -70% 0px', threshold: 0 });
      items.forEach(function (it) {
        var el = document.getElementById(it.id);
        if (el) obs.observe(el);
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-pf-article]').forEach(initArticle);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
